// Pure helpers for working with Start.GG identifiers (no framework dependency).

// Accepts a bare tournament slug or a full Start.GG URL and returns just the slug.
export function extractTournamentSlug(input: string): string {
  const trimmed = input.trim();
  const match = trimmed.match(/tournament\/([^/?#]+)/i);
  return match ? match[1] : trimmed;
}
